/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { getScrollPosition, getY, scrollGetY, setY } from 'utils/scrolling';
import { getSvgIcon } from '../../../resources';
import AppStyle from '../../../scss/main/App.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from 'store/types';

const WAD: React.FC<{}> = () => {

  const scrollY = useSelector((state: RootState) => state.ui.scrollY);

  const image1: any = useRef<HTMLInputElement>(null);
  const image2: any = useRef<HTMLInputElement>(null);

  const image1Y: number = (image1 && image1.current && image1.current.offsetTop) || 0
  const image2Y: number = (image2 && image2.current && image2.current.offsetTop) || 0

  if (getY('web-image1Y') !== image1Y && image1Y !== 0) {
    setY('web-image1Y', image1Y)
  }

  if (getY('web-image2Y') !== image2Y && image2Y !== 0) {
    setY('web-image2Y', image2Y)
  }

  return (
    <div className={AppStyle["skill-wad"]}>
      <div>
        <div>
          <div>
            How I Do
          </div>
        </div>
        <div>
          <div>
            <div>Most of the current websites exist as web applications. Their biggest advantage is not only that they can be browsed on ordinary PCs, but they can also be adapted to operate on different devices, and even the standard design of mobile applications can be used to make web applications, also with an experience comparable to mobile apps.</div>
            <div>Both are the current mainstream web application development technologies. Their biggest common point is using the Single-page application as the standard, and the DOM can be reused so that some heavy web applications can also greatly reduce the consumption of hardware resources to achieve a smooth user experience.</div>
          </div>
        </div>
      </div>
      <div ref={image1} >
        <img src={process.env.REACT_APP_CDN_PATH + "060c4ac7fba0c3cc2beaafef5693c27d365dbe66b3c4c7b3e6071e34a48cfa37.webp"} style={{ willChange: 'transform', transform: `translate3d(0px, ${scrollGetY(getScrollPosition(), getY(`web-image1Y`), 1.25)}%, 0px)` }} />
      </div>
      <div>
        <div>
          Development<br />Steps
        </div>
        <div>
          <div>
            <div>
              1
            </div>
            <div>
              Research
            </div>
            <div>
              Before everything starts, development goals, requirements and timetables must be established. During this phase, I will help you finalize the functions list, prepare the technical requirements, and develop the application architecture with a roadmap of interactivity.
            </div>
          </div>
          <div>
            <div>
              2
            </div>
            <div>
              UX/UI Design
            </div>
            <div>
              The user first impression of your web application comes from the user interface (UI) design. A good design does not lie in whether it has complicated interactive functions or animations, but whether it makes it easy for users to understand what your web application is and what it does. I can create an individualized design for your unique audience while anticipating your needs and expectations.
            </div>
          </div>
          <div>
            <div>
              3
            </div>
            <div>
              Frontend Development
            </div>
            <div>
              After designing the user interface and detailed planning, I can start the development work. At this stage, I will develop completely based on the DESIGNED user interface, and add some animation and interactive functions to enhance the overall user experience.
            </div>
          </div>
          <div>
            <div>
              4
            </div>
            <div>
              Backend Development
            </div>
            <div>
              Some information-type or shop-type web applications need a place to process, store and calculate data. Depending on functionality, this may include storing user data, storing photo and video content, search, showing actual products, and more. I will develop different types of backends according to the actual needs of the project.
            </div>
          </div>
          <div>
            <div>
              5
            </div>
            <div>
              Quality Assurance and Improvement
            </div>
            <div>
              Although it is inevitable to debug different vulnerabilities during development, a complete debugging process is one of the important factors to ensure the stability of the project before the project is released. Considering that you may low level server, I will also add a CDN at this stage to speed up the page loading speed and enhance the experience.
            </div>
          </div>
          <div>
            <div>
              6
            </div>
            <div>
              SEO and Release
            </div>
            <div>
              When the development is complete, SEO is the last step that needs to be processed. SEO is one of the factors that determines whether your web application can gain high exposure in search engines such as Google or Bing. At this stage, I will add analysis files to export website data so that I can better understand how to improve your web application exposure.
            </div>
          </div>
        </div>
      </div>
      <div ref={image2}>
        <img src={process.env.REACT_APP_CDN_PATH + "9c652b84400d232225a8ae8e3d3410220f1872359a1be327b6e15e6060cb20b7.webp"} style={{ willChange: 'transform', transform: `translate3d(0px, ${scrollGetY(getScrollPosition(), getY(`web-image2Y`), 1.25)}%, 0px)` }} />
      </div>
      <div>
        <div>
          Main<br />Technology
        </div>
        <div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'framework' })}` }} />
            <div>
              Frontend Frameworks
            </div>
            <div>
              React and Vue are one of the main web application development tools I currently use, but I am also happy to use Angular and ASP.NET, and even use PWA as a standard for development. Everything will be based on the development requirements of the project.
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'me' })}` }} />
            <div>
              Mobile Experience
            </div>
            <div>
              Nowadays, more users use Smartphones to browse the web than PCs, so it is very important to make web applications an experience comparable to mobile applications. I can also develop with PWA (a technology that can install web applications on smartphones, just like general mobile applications) standards to maximize the use of a web application.
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'seo' })}` }} />
            <div>
              SEO
            </div>
            <div>
              Google Analytics is my main SEO tool, it can track a website activity such as session duration, pages per session, bounce rate, etc. of individuals using the site, along with the information on the source of the traffic. It can be integrated with Google Ads, with which users can create and review online campaigns by tracking landing page quality and conversions (goals). Goals might include sales, lead generation, viewing a specific page, or downloading a particular file.
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'ux' })}` }} />
            <div>
              Design Thinking
            </div>
            <div>
              Design thinking is a non-linear, iterative process that teams use to understand users, challenge assumptions, redefine problems and create innovative solutions to prototype and test. Involving five phases—Empathize, Define, Ideate, Prototype and Test—it is most useful to tackle problems that are ill-defined or unknown.
            </div>
          </div>
        </div>
      </div>
      <div>
        <div>
          List of<br />Development<br />Technologies
        </div>
        <div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'rn' })}` }} />
            <div>
              React
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'next' })}` }} />
            <div>
              Next.js
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'redux' })}` }} />
            <div>
              Redux
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'relay' })}` }} />
            <div>
              Relay
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'vue' })}` }} />
            <div>
              Vue
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'angular' })}` }} />
            <div>
              Angular
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'rails' })}` }} />
            <div>
              Ruby on Rails
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'asp' })}` }} />
            <div>
              ASP.NET Core
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'pwa' })}` }} />
            <div>
              PWA
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'sass' })}` }} />
            <div>
              SASS
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className={`${AppStyle["buttonLine"]}`}>
          <Link to='/skills'>
            Show Me Others
            <div className={AppStyle["button-border"]} />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default WAD